import { render, staticRenderFns } from "./WrapperCredit.vue?vue&type=template&id=047cd2fa&"
import script from "./WrapperCredit.vue?vue&type=script&lang=js&"
export * from "./WrapperCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports